import { useFlag } from '@unleash/proxy-client-react'

export default () => {
  const mes_3653_limit_import_csv_300 = useFlag('mes_3653_limit_import_csv_300')
  const csv_exceeds_limit = useFlag('csv_exceeds_limit')
  const mes_3841_show_crm_export = useFlag('mes_3841_show_crm_export')
  const mes_1960_new_signin_signup = useFlag('mes_1960_new_signin_signup')
  const mes_3832_new_design_compose_message = useFlag(
    'mes_3832_new_design_compose_message',
  )
  const mes_3937_redesign_group_page = useFlag('mes_3937_redesign_group_page')
  const mes_3908_place_profile = useFlag('mes_3908_place_profile')
  const mes_4297_tiptap_editor = useFlag('mes_4297_tiptap_editor')
  const mes_4367_attachment_gallery = useFlag('mes_4367_attachment_gallery')
  const mes_4164_profile_password = useFlag('mes_4164_profile_password')
  const mes_2832_new_template_initial_message = useFlag(
    'mes_2832_new_template_initial_message',
  )
  const mes_4165_teammember_tranfer_otp_password = useFlag(
    'mes_4165_teammember_tranfer_otp_password',
  )

  const mes_4687_FE_line_integration = useFlag('mes_4687_FE_line_integration')
  const mes_4885_initial_msg_title = useFlag('mes_4885_initial_msg_title')
  const mes_2175_new_live_preview = useFlag('mes_2175_new_live_preview')
  const mes_5172_csv_invite = useFlag('mes_5172_csv_invite')
  const mes_3198_poll_preview_translation = useFlag(
    'mes_3198_poll_preview_translation',
  )

  return {
    mes_3653_limit_import_csv_300,
    csv_exceeds_limit,
    mes_3841_show_crm_export,
    mes_1960_new_signin_signup,
    mes_3937_redesign_group_page,
    mes_3832_new_design_compose_message,
    mes_3908_place_profile,
    mes_4164_profile_password,
    mes_4367_attachment_gallery,
    mes_4297_tiptap_editor,
    mes_2832_new_template_initial_message,
    mes_4165_teammember_tranfer_otp_password,
    mes_4687_FE_line_integration,
    mes_4885_initial_msg_title,
    mes_2175_new_live_preview,
    mes_5172_csv_invite,
    mes_3198_poll_preview_translation,
  }
}
